import { StoreSelector } from '@src/types';

import { State } from './types';

export const selector: StoreSelector<State, 'queue'> = {
  queue: (state) => state.queue,
};
